import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";
import { TextField } from "components/UI";
import { useChurchStore, useUpdateChurch } from "features/churches";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

const legalNameSchema = yup.object({
  legal_name: yup.string().required("Legal name is required")
});

export const LegalName = () => {
  const churchUpdateMutation = useUpdateChurch();
  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      legal_name: selectedChurch?.legal_name
    },
    resolver: yupResolver(legalNameSchema)
  });

  useEffect(() => {
    if (selectedChurch) {
      setValue("legal_name", selectedChurch.legal_name);
    }
  }, [selectedChurch]);

  const onSubmit = data => {
    churchUpdateMutation.mutate({
      churchData: { legal_name: data.legal_name },
      churchId: selectedChurch?.id
    });
  };

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant="h5" fontWeight={700}>
          What&apos;s your legal name?
        </Typography>
        <Typography variant="caption">
          Please enter the full legal name of your church as registered with the
          government.
        </Typography>
        <TextField
          label="Enter Legal Name"
          name="legal_name"
          register={register}
          onBlur={handleSubmit(onSubmit)}
          error={!!errors.legal_name?.message}
          helperText={
            errors.legal_name?.message ||
            "Example: Ethiopian Evangelical Church Mekane Yesus Bole Congregation"
          }
          hasNoBg
        />
      </Stack>
    </>
  );
};
